import { PublicationSetting } from 'data/generated/graphql';
import { isValidURL } from 'utils/url';

import {
  CHART_ID_PATTERN,
  GUID_PATTERN,
  IMAGE_MANAGER_ID_PATTERN,
  MediaTypes
} from 'components/altsumm-modal/components/media-input/MediaInput.utils';

export function getDomain(publicationSettings: PublicationSetting | undefined, type: MediaTypes | '', value: string) {
  if (type === 'url' && !isValidURL(value)) {
    return '';
  }
  if (type === 'image' && !IMAGE_MANAGER_ID_PATTERN.test(value)) {
    return '';
  }
  if (type === 'video' && !GUID_PATTERN.test(value)) {
    return '';
  }
  if (type === 'chart' && !CHART_ID_PATTERN.test(value.trim())) {
    return '';
  }
  switch (type) {
    case 'image':
      return `${publicationSettings?.snippetyIMDomain ?? ''}/${value}`;
    case 'chart':
      CHART_ID_PATTERN.lastIndex = 0;

      const match = CHART_ID_PATTERN.exec(value.trim());

      if (!match?.groups?.id) {
        return '';
      }

      return `${publicationSettings?.snippetyChartDomain ?? ''}/${match.groups.id}`;
    case 'video':
      return `${publicationSettings?.snippetyVideoDomain ?? ''}${value}`;
    case 'url':
      return value;
    default:
      return '';
  }
}
